import React from 'react';
import s from './ToolsButtons.module.css';
import IconCut from '../../../../shared/ui/icons/IconCut';

interface CutButtonProps {
    quillRef: React.RefObject<any>;
    isActive?: boolean;
    onClick?: () => void;
}

const CutButton: React.FC<CutButtonProps> = ({ quillRef, isActive, onClick }) => {
    const handleCut = async () => {
        if (onClick) onClick();

        if (!quillRef.current) return;

        const editor = quillRef.current.getEditor();
        const range = editor.getSelection();

        if (range && range.length > 0) {
            const selectedText = editor.getText(range.index, range.length);

            try {
                await navigator.clipboard.writeText(selectedText);
            } catch (err) {
                console.error('Error copying text:', err);
            }

            editor.deleteText(range.index, range.length);
        }
    };

    return (
        <button className={`${s.container}`} onClick={handleCut}>
            <IconCut width={16} />
            <p>Cut</p>
        </button>
    );
};

export default CutButton;
